// extracted by mini-css-extract-plugin
module.exports = {"row":"Row_row__PLgC_"};